module.exports = __webpack_public_path__ + "img/fig01.64d8bce3.jpg";